/** Locul cifrelor unei pagini cât timp vin din backend.
 *
 *  Paginile care adună cifre din mai multe cereri (verificările structurii,
 *  devizul) le socoteau din ce sosise până atunci, așa că numerele urcau și se
 *  schimbau o secundă-două după intrare. O cifră parțială arată exact ca una
 *  finală, deci nu se arată nimic până nu e finală: aici stau bare gri, fără
 *  nicio cifră, iar pagina le înlocuiește dintr-o dată. */
import { useT } from "../i18n";

/** lățimile barelor, ca fracțiune din rând: un text, nu un tabel de egale */
const LATIMI = [0.42, 0.88, 0.74, 0.93, 0.61, 0.8];

export default function SeIncarca({ randuri = 6 }: { randuri?: number }) {
  const t = useT();
  return (
    <div className="se-incarca" aria-busy="true" aria-label={t("comun.se_incarca")}>
      {Array.from({ length: randuri }, (_, i) => (
        <span key={i} className="se-incarca-bara"
              style={{ width: `${LATIMI[i % LATIMI.length] * 100}%` }} />
      ))}
      <span className="note">{t("comun.se_incarca")}</span>
    </div>
  );
}
